export interface IRelayGroupMetadata {
    id: string;
    name: string;
    description?: string;
    updatedAt?: Date;
    agentCount: number;
    endpointCount: number;
}

export interface IRelayGroupResponse {
    results: IRelayGroupMetadata[];
    totalCount: number;
}

export interface IRelayEndpointsResponse {
    results: IRelayEndpointResponseDto[];
    totalCount: number;
}

export interface IRelayAgentsResponse {
    results: IRelayAgentResponseDto[];
    totalCount: number;
}

export interface IRelayEndpointFormDto {
    id?: string;
    name: string;
    description?: string;
    /** Used when EnableRelayTCP is off (single URL field). */
    url?: string;
    /** Used when EnableRelayTCP is on (scheme dropdown). */
    scheme?: string;
    /** Used when EnableRelayTCP is on (host text field). */
    host?: string;
    isExisting?: boolean;
    healthCheckPath?: string;
}

export interface IRelayGroupRegistrationFormDto {
    name: string;
    description?: string;
    endpoints: IRelayEndpointFormDto[];
}

export interface IRelayEndpointRequestDto {
    id?: string;
    name: string;
    description?: string;
    url: string;
    isExisting?: boolean;
    healthCheckPath?: string;
}

export interface IRelayGroupRegistrationRequestDto {
    name: string;
    description?: string;
    endpoints: IRelayEndpointRequestDto[];
}

export enum RelayEndpointScheme {
    Http = 'http',
    Https = 'https',
    Tcp = 'tcp',
}

export interface IRelayEndpointResponseDto {
    id: string;
    groupId: string;
    name: string;
    description?: string;
    url: string;
    connectivityStatus?: RelayHealthStatus;
    lastCheckedAt: Date;
    healthCheckPath?: string;
    scheme: RelayEndpointScheme;
}

export enum RelayHealthStatus {
    Live = 'Live',
    Warning = 'Warning',
    Offline = 'Offline',
}

export type IRelayEndpointHealthStatusMap = Record<string, RelayHealthStatus | number | boolean>;

export interface IRelayGroupRegistrationResponseDto {
    id: string;
    name: string;
    description?: string;
    endpoints: IRelayEndpointResponseDto[];
}

export enum RelayAgentHealthStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export enum RelayAgentPlatform {
    Windows = 'Windows',
    Linux = 'Linux',
}

export enum RelayClientSupportStatus {
    UpToDate = 'UpToDate',
    UpdateAvailable = 'UpdateAvailable',
    OutOfSupport = 'OutOfSupport',
}

export interface IRelayAgentResponseDto {
    id: string;
    hostname: string;
    healthStatus: RelayAgentHealthStatus;
    version: string;
    platform: RelayAgentPlatform;
    groupId: string;
    secretId?: string;
    supportStatus?: RelayClientSupportStatus;
}

export type IRelayAgentHealthStatusMap = Record<string, RelayAgentHealthStatus>;

export interface IBulkHealthCheckRequest {
    endpointUuids?: string[];
    agentUuids?: string[];
}

export interface IBulkHealthCheckResponse {
    endpoints?: IRelayEndpointHealthStatusMap;
    agents?: IRelayAgentHealthStatusMap;
    hasAgentMismatch?: boolean;
}

export interface IRelayGroupClientConfigDto {
    config: string;
}
